import GitHubIcon from "../../static/assets/media/github.svg"
import SoundCloudIcon from "../../static/assets/media/soundcloud.svg"

export default {
  github: GitHubIcon,
  soundcloud: SoundCloudIcon,
}
